import MarketingNewsletter from './MarketingNewsletter';

export default MarketingNewsletter;
